import { render } from "./logout.vue?vue&type=template&id=0fd1faf9&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"

import "./logout.vue?vue&type=style&index=0&id=0fd1faf9&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd1faf9"]])

export default __exports__